import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'

const MainWrap = styled.div`
  display: block;
  padding-top: 76px;
`
const MainPcFloatBtn = styled.img`
  width: 48px;
  height: 48px;
  position: fixed;
  bottom: 64px;
  right: 64px;
  z-index: 1;
  cursor: pointer;
`
const MainMoFloatBtn = styled.div<{ active: string }>`
  position: fixed;
  bottom: 0;
  width: 100%;
  display: inline-block;
  z-index: 996;
  text-align: center;
  line-height: 56px;
  height: 56px;
  font-family: NanumSquareNeoHeavy, sans-serif;
  background: ${COLOR.point1};
  opacity: ${(props) => (props.active === 'active' ? '1' : '0')};
  visibility: ${(props) => (props.active === 'active' ? 'unset' : 'hidden')};
  transition: ${(props) => (props.active === 'active' ? 'opacity 500ms, visibility 500ms;' : 'opacity 500ms, visibility 500ms;')};

  cursor: pointer;

  > span {
    color: ${COLOR.white};
    font-size: 18px;
  }
`

export { MainMoFloatBtn, MainPcFloatBtn, MainWrap }
